import { createFeenyAction } from 'app/api/redux-feeny/action';
import { needsAssignmentFetch } from 'app/api/redux-feeny/assignments/selectors';

export const ALL_ASSIGNMENTS = 'Feeny.Assignments.all';
export const DELETE_ASSIGNMENT = 'Feeny.Assignments.delete';

const baseListAssignments = createFeenyAction(ALL_ASSIGNMENTS);

export function tryListAllAssignments() {
  return function(dispatch, getState) {
    if (needsAssignmentFetch(getState())) {
      dispatch(baseListAssignments());
    }
  };
}

export const deleteAssignment = createFeenyAction(DELETE_ASSIGNMENT);



// WEBPACK FOOTER //
// ./src/app/api/redux-feeny/assignments/actions.js